<template>
  <v-main>
    <v-card class="test-question-card pa-3 pl-6">
      <v-form @submit.prevent="emitToEditTest">
        <v-row>
          <v-col cols="9" md="10" lg="11" sm="10">
            <v-row no-gutters align="center">
              <v-text-field
                label="Question"
                v-model="question.qtext"
                class="text-input"
                id="q_input"
                :error-messages="formErrors.questionError"
                required
              ></v-text-field>
              <v-btn icon v-if="!question.imageEnabled" @click="question.imageEnabled = true">
                <v-icon>mdi-camera</v-icon>+
              </v-btn>
            </v-row>
            <v-row no-gutters align="center" v-if="question.imageEnabled">
              <v-file-input
                label="Question Image (Optional)"
                prepend-icon="mdi-camera"
                class="image-input"
                accept="image/*"
                @change="addImageToQuestion"
              ></v-file-input>
              <v-btn icon @click="question.imageEnabled = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-row>
            <div>
              <v-switch v-model="question.isSubjective" label="Subjective"></v-switch>
            </div>

            <b color="red">{{ formErrors.genErrors }}</b>
            <!-- will only show if isSubjective is false -->
            <div class="objective" v-if="!question.isSubjective">
              <div v-for="(option, index) in question.options" :key="option.id">
                <OptionInput
                  :option="option"
                  :index="index"
                  v-on:removeSelfFromOptionsList="removeSelfFromOptionsList"
                />
              </div>
              <div class="text-center">
                <v-btn @click="addEmptyOption" class="ma-2 add-option-btn" outlined>Add Option</v-btn>
              </div>
              <v-select
                :items="question.options"
                :item-text="getOptionItemText"
                v-model="question.correctOption"
                @change="setCorrectOption"
                item-value="item"
                label="Correct Option"
                required
                return-object
              ></v-select>
            </div>
          </v-col>
          <v-col cols="3" md="2" lg="1" sm="2">
            <div class="d-flex align-center flex-column">
              <v-text-field type="number" v-model.number="question.marks" label class="marks-input"></v-text-field>
              <h5>Marks</h5>
            </div>
          </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
        <div class="text-right">
          <v-btn
            color="primary"
            type="submit"
            class="ma-2 add-question-btn"
            :disabled="isLoading"
          >Add Question</v-btn>
        </div>
      </v-form>
    </v-card>
    <v-snackbar v-model="formErrors.isGenErrors">
      {{ formErrors.genErrors }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="formErrors.genErrors = null">Close</v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>

<script>
import OptionInput from "./OptionInput.vue";
import Helper from "@utils/misc";
import { mapGetters } from "vuex";

export default {
  name: "TestQuestionForm",
  components: {
    OptionInput,
  },
  data() {
    return {
      isSubjective: false,
      formErrors: {
        questionError: null,
        genErrors: null,
        isGenErrors: false,
      },
      question: {
        tid: this.$route.params.tid,
        isSubjective: false,
        imageEnabled: false,
        correctOption: null,
        marks: 1,
        options: [
          {
            imageEnabled: false,
            deletable: false,
            isCorrect: false,
          },
          {
            imageEnabled: false,
            deletable: false,
            isCorrect: false,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
  methods: {
    //adds an empty option to the optionsList
    addEmptyOption() {
      this.question.options.push({
        imageEnabled: false,
        deletable: true,
        isCorrect: false,
      });
    },
    //removes an option from the optionsList
    removeSelfFromOptionsList(option) {
      if (!option.deletable) return;
      this.question.correctOption = null;
      this.question.options.splice(this.question.options.indexOf(option), 1);
    },
    // gets correct option item text
    getOptionItemText(item) {
      return !item.op
        ? "Option " + (this.question.options.indexOf(item) + 1)
        : item.op;
    },
    // adds image to a question
    async addImageToQuestion(file) {
      if (file) {
        this.question.image = await Helper.toBase64(file);
      }
    },
    // validates all fields
    validateFields() {
      // resetting errors
      this.formErrors = {
        questionError: null,
        genErrors: null,
        isGenErrors: false,
      };

      this.question.options.map((o) => (o.errorMessage = null));

      if (!this.question.qtext) {
        this.formErrors.questionError = "This field is required";
        return false;
      }

      if (!this.question.marks || this.question.marks <= 0) {
        this.formErrors.isGenErrors = true;
        this.formErrors.genErrors = "Please enter valid marks";
        return false;
      }

      if (this.question.isSubjective) {
        return true;
      }

      // option validation
      var optionError = false;
      this.question.options.map((o) => {
        if (!o.op) {
          optionError = true;
        }
      });

      if (optionError) {
        this.formErrors.isGenErrors = true;
        this.formErrors.genErrors = "All option fields are required";
        return false;
      }

      if (!this.question.correctOption) {
        this.formErrors.isGenErrors = true;
        this.formErrors.genErrors = "Choose a correct option";
        return false;
      }
      return true;
    },
    // uploads question model to serve
    emitToEditTest() {
      if (!this.validateFields()) return;
      this.$emit("uploadDetails", this.question);
    },
    // finds option and sets isCorrect
    setCorrectOption(option) {
      this.question.options.map((o) => (o.isCorrect = false));
      option.isCorrect = true;
    },
  },
};
</script>

<style scoped>
i {
  cursor: pointer;
}
.test-question-card {
  margin-top: 30px;
  padding: 10px;
  padding-left: 30px;
  border-left: 5px solid #009688;
  border-radius: 20px;
}
h1.test-name {
  border-bottom: 1px solid #009688;
}
.marks {
  font-size: 40px;
}
.text-input,
.image-input {
  color: #009688;
}
.marks-input {
  max-width: 25px;
}
.marks-input >>> input {
  text-align: center;
}
.marks-input >>> input::-webkit-inner-spin-button,
.marks-input >>> input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
.text-center {
  text-align: center;
}
.add-option-btn {
  color: #009688;
  border-color: #009688;
  font-weight: bold;
  border: 1px solid #009688;
}
.add-question-btn {
  color: white;
}
.text-right {
  padding: 20px;
  text-align: end;
}
</style>
